import { useInView } from "../../../hooks/useInView";

const wrestlers = [
  {
    id: 1,
    name: "ELI EMERSON",
    image: "https://framerusercontent.com/images/s15xRGLkH8MaLzKk5GrKEk6hjM.png",
  },
  {
    id: 2,
    name: "EL CHIVO",
    image: "https://framerusercontent.com/images/T1YNzaqHD4hpOhd9PSjLCXdFEXM.png",
  },
  {
    id: 3,
    name: "THE SAMOAN SHOOTER",
    image: "https://framerusercontent.com/images/7a0o2veawpGPffshoaNr1eI1oA.png",
  },
  {
    id: 4,
    name: "THE CANDY GIRL",
    image: "https://framerusercontent.com/images/0WCLvkNaQ1AfycoZYPGk9qpzKA.png",
  },
  {
    id: 5,
    name: "THE WRETCHED ONE",
    image: "https://framerusercontent.com/images/QIbllmWYmataKTPFcaEJRxlm9hM.png",
  },
];

function WrestlerCard({ name, image }: { name: string; image: string }) {
  return (
    <div className="relative flex-shrink-0 w-60 md:w-72 h-80 md:h-96 overflow-hidden group cursor-pointer">
      <img
        src={image}
        alt={name}
        className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        style={{ transition: "transform 0.7s cubic-bezier(0.22, 1, 0.36, 1)" }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />
      {/* Hover orange strip */}
      <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-orange-500 scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />
      <div className="absolute bottom-0 left-0 right-0 p-5">
        <h4 className="font-condensed font-black text-white text-xl uppercase tracking-wide group-hover:text-orange-400 transition-colors duration-200">
          {name}
        </h4>
      </div>
    </div>
  );
}

export default function RosterSection() {
  const doubled = [...wrestlers, ...wrestlers];
  const { ref, inView } = useInView();

  return (
    <section className="bg-white py-16 md:py-24 overflow-hidden">
      <div
        ref={ref as React.RefObject<HTMLElement>}
        className="max-w-7xl mx-auto px-6 lg:px-10 mb-12"
      >
        <div
          className={`flex flex-col lg:flex-row lg:items-end justify-between gap-6 anim-hidden ${inView ? "animate-fade-in-up" : ""}`}
        >
          <div>
            <div className="inline-block border border-gray-300 text-gray-500 font-condensed font-semibold text-xs uppercase tracking-widest px-3 py-1 mb-4">
              Real People. Real Results.
            </div>
            <h2 className="font-condensed font-black text-gray-900 text-4xl md:text-5xl lg:text-6xl uppercase tracking-tight">
              The Roster
            </h2>
            <div className={`mt-3 h-0.5 bg-orange-500 w-16 anim-hidden ${inView ? "line-grow delay-200" : ""}`} />
          </div>
          <p
            className={`text-gray-500 text-sm md:text-base max-w-md lg:text-right anim-hidden ${inView ? "animate-fade-in-right delay-200" : ""}`}
          >
            This is the lineup that packs arenas. Explore the faces of PWA, then catch them live at the next show.
          </p>
        </div>
      </div>

      {/* Marquee */}
      <div className="pause-on-hover overflow-hidden">
        <div className="flex gap-4 animate-marquee w-max">
          {doubled.map((w, i) => (
            <WrestlerCard key={`${w.id}-${i}`} name={w.name} image={w.image} />
          ))}
        </div>
      </div>
    </section>
  );
}
